import { PlatformAdapter } from '@/platform/types';

export class WebPlatformAdapter implements PlatformAdapter {
  label = 'web-touch';
  isNative = false;

  vibrate(pattern: number | number[]) {
    if ('vibrate' in navigator) {
      navigator.vibrate(pattern);
    }
  }

  openExternalUrl(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
